module.exports = __webpack_public_path__ + "static/media/IMG_2096.3cf02709.JPG";